'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dPartial$002dFunction$0024$0024anon$00241 from "./scala.-Partial-Function$$anon$1.js";
var $p;
/** @constructor */
function $c_s_PartialFunction$() {
  this.ws = null;
  this.gb = null;
  $n_s_PartialFunction$ = this;
  this.ws = new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((_$2$2) => this.ws));
  this.gb = new $j_scala$002e$002dPartial$002dFunction$0024$0024anon$00241.$c_s_PartialFunction$$anon$1();
}
export { $c_s_PartialFunction$ as $c_s_PartialFunction$ };
$p = $c_s_PartialFunction$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_PartialFunction$;
/** @constructor */
function $h_s_PartialFunction$() {
}
export { $h_s_PartialFunction$ as $h_s_PartialFunction$ };
$h_s_PartialFunction$.prototype = $p;
$p.Xi = (function(x) {
  return (this.ws === x);
});
var $d_s_PartialFunction$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_PartialFunction$, "scala.PartialFunction$", ({
  rC: 1
}));
export { $d_s_PartialFunction$ as $d_s_PartialFunction$ };
var $n_s_PartialFunction$;
function $m_s_PartialFunction$() {
  if ((!$n_s_PartialFunction$)) {
    $n_s_PartialFunction$ = new $c_s_PartialFunction$();
  }
  return $n_s_PartialFunction$;
}
export { $m_s_PartialFunction$ as $m_s_PartialFunction$ };
